import { motion } from 'framer-motion';
import WorldMap from '../components/WorldMap';
import { SectionHeader, FadeUp } from '../components/SectionHeader';
import { COUNTRIES, FUTURE_REGIONS, IMAGES } from '../data/content';

export default function GlobalPresence() {
  return (
    <div className="bg-white">
      <section className="relative pt-44 pb-20 bg-[#0D1B2A] grain overflow-hidden">
        <div
          className="absolute inset-0 opacity-25"
          style={{
            backgroundImage: `url(${IMAGES.hero})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <div className="absolute inset-0 bg-[#0D1B2A]/82" />
        <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
          <div className="overline text-white/80 flex items-center gap-3 mb-6">
            <span className="gold-rule" /> Global Presence
          </div>
          <h1 className="font-display text-white text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight max-w-4xl leading-[1.05]">
            A platform with <span className="text-[#D4AF37]">international reach.</span>
          </h1>
          <p className="mt-8 text-white/75 text-lg max-w-3xl leading-relaxed">
            From our Mumbai headquarters, we deliver projects across India, the Middle East and
            Africa — with active expansion zones across emerging industrial corridors.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10">
          <FadeUp className="bg-[#F5F7FA] p-6 md:p-10 border border-[#0D1B2A]/8">
            <WorldMap />
          </FadeUp>
        </div>
      </section>

      <section className="bg-[#F5F7FA] py-20 md:py-24">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10">
          <SectionHeader overline="Active Regions" title="Where we operate today." />
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {COUNTRIES.map((c, i) => (
              <motion.div
                key={c.code}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.45, delay: i * 0.05 }}
                className="bg-white p-7 border border-[#0D1B2A]/10 card-hover-lift"
              >
                <div className="text-4xl">{c.flag}</div>
                <div className="mt-4 font-display font-bold text-xl text-[#0D1B2A]">
                  {c.name}
                </div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] font-semibold mt-1">
                  {c.role}
                </div>
                <div className="mt-5 flex items-baseline gap-2">
                  <span className="font-stat font-extrabold text-3xl text-[#0D1B2A]">
                    {c.projects}
                  </span>
                  <span className="text-xs uppercase tracking-[0.2em] text-[#4B5563]">
                    Projects
                  </span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 md:py-24 bg-white">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10">
          <SectionHeader
            overline="Expansion Zones"
            title="Where we're going next."
            lead="Active engagement and capability development across emerging industrial corridors."
          />
          <div className="mt-10 flex flex-wrap gap-3">
            {FUTURE_REGIONS.map((r) => (
              <span
                key={r}
                className="border border-[#0D1B2A]/15 text-[#0D1B2A] px-4 py-2 text-sm tracking-wide hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"
              >
                {r}
              </span>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
